export default "__VITE_ASSET__2qGzpY5g__"